import { roundNumber } from "utils/roundNumber";

// constants/wisdomBenchmarks.js
export const WISDOM_BENCHMARKS = [
    {
        key: "EEBM", name: "الحوكمة و الأثر المؤسسي", color: "#10b981", subs: [
            { code: "W", name: "تقييم بيئة العمل", color: "#A0BECD" },
            { code: "WCP", name: "مشاركة مجتمعية", color: "#8DD496" },
            { code: "TMS", name: "كفاءة انجاز المهام", color: "#520a9c" },
        ]
    },
    {
        key: "EPBM", name: "العملية التعليمية", color: "#f59e0b", subs: [
            { code: "EDU", name: "تقييم البيئة التعليمية", color: "#D86FDF" },
            { code: "C", name: "تقييم المنهج", color: "#5FE39D" },
            { code: "T", name: "تقييم اداء المعلم", color: "#B09509" },
        ]
    },
    {
        key: "APBM", name: "التقدم الأكاديمي", color: "#10b981", subs: [
            { code: "PRO", name: "مشروع التخرج", color: "#2e6f00" },
            { code: "FO", name: "الاختبار التكويني", color: "#e43002" },
            { code: "SU", name: "الاختبار التجميعي", color: "#88a064" },
        ]
    },
    {
        key: "ODBM", name: "الانضباط العام", color: "#3b82f6", subs: [
            { code: "sessions", name: "الحصص المنفذه", color: "#C25A6B" },
            { code: "STA", name: "حضور الطلاب", color: "#5A9FC2" },
            { code: "STB", name: "انضباط الطلاب", color: "#5AC2B1" },
            { code: "DO", name: "الطابور الصباحي", color: "#C2B15A" },
        ]
    },
    {
        key: "TQBM", name: "جودة التدريب الميداني", color: "#f59e0b", subs: [
            { code: "TG", name: "انتظام التدريب", color: "#aa4642" },
            { code: "FT", name: "تقييم التدريب", color: "#925515" },
            { code: "CA", name: "اكتساب الجدارات", color: "#925515" },
        ]
    }
];

// constants/wisdomBenchmarks.js (below WISDOM_BENCHMARKS)
export const buildOrgStandards = (month) =>
    WISDOM_BENCHMARKS.map(({ key, name, color }) => ({
        name,
        color,
        score: roundNumber(month?.[key]?.[`total${key}`]) || 0,
    }));

export const buildOrgSubStandards = (month) =>
    WISDOM_BENCHMARKS.map(({ key, name, subs }) => ({
        name,
        score: roundNumber(month?.[key]?.[`total${key}`]) || 0,
        subData: subs.map(({ code, name, color }) => {
            const data = month?.[key]?.[code];
            return {
                name,
                code,
                color,
                score: roundNumber(data?.avgScore) || 0,
                codes: data?.codeScores || [],
                scores: data?.scores || [],
                no_of_forms: data?.no_of_forms || 0,
            };
        }),
    }));